import makeStyles from "@mui/styles/makeStyles";

const styles = makeStyles(() => ({
  status: {
    width: "fit-content",
  },
  button: {
    cursor: "pointer",
  },
  buttonText: {
    whiteSpace: "nowrap",
  },
  label: {
    display: "flex",
  },
  changeStatusButton: {
    whiteSpace: "nowrap",
    "& span > div": {
      display: "flex",
      alignItems: "center",
    },
  },
}));

export default styles;
